import {
  ContactsOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  PieChartOutlined,
  CloudUploadOutlined,
  YoutubeOutlined,
  VideoCameraOutlined,
  LockOutlined
} from '@ant-design/icons';
import { ElementType } from 'react';
import { EAdminRoles } from 'shared/types';

export type SubSidebarItem = {
  title: string;
  link: string;
  allowedRoles: EAdminRoles[];
  subItems?: SubSidebarItem[];
};

export type SidebarItem = {
  title: string;
  link: string;
  icon: ElementType;
  subItems?: SubSidebarItem[];
  allowedRoles: EAdminRoles[];
};

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    title: 'Video Tour',
    link: '/d/video-tour',
    icon: VideoCameraOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    title: 'Manage School Files',
    link: '/d/file-upload',
    icon: CloudUploadOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    title: 'Manage School YouTube Links',
    link: '/d/youtube-links',
    icon: YoutubeOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    title: 'School Sessions Report',
    link: '/d/reports/sessions',
    icon: PieChartOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    title: 'School Users Report',
    link: '/d/reports/users',
    icon: PieChartOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN],
    subItems: [
      {
        title: 'School LE Completion Report',
        link: '/d/reports/le-completion-report',
        allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
      },
      {
        title: 'School LE Time in Stations Report',
        link: '/d/reports/le-time-stations-report',
        allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
      },
      {
        title: 'Student Completion Report',
        link: '/d/reports/student-completion-report',
        allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
      }
    ]
  },
  {
    title: "Manage My School's Users",
    link: '/d/manage-users',
    icon: ContactsOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    title: 'Super Admin',
    link: '/d/super-admin',
    icon: LockOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN],
    subItems: [
      {
        title: 'Students',
        link: '/d/students',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'Schools',
        link: '/d/schools',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'School Admins',
        link: '/d/admins',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'School Analytics',
        link: '/d/reports/dashboard',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'Teacher Login History',
        link: '/d/reports/teacher-logins',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'Alabama Study School Report',
        link: '/d/reports/teacher-report',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'Global LE Reports',
        link: '/d/reports/global-le-reports',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'Watson Chat',
        link: '/d/reports/watson-chat',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      },
      {
        title: 'Data Buddy Log',
        link: '/d/reports/data-buddy-logs',
        allowedRoles: [EAdminRoles.SUPER_ADMIN]
      }
    ]
  },
  {
    title: 'My Settings',
    link: '/d/settings',
    icon: SettingOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    title: 'Help',
    link: '/d/help',
    icon: QuestionCircleOutlined,
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  }
];
